<template>
  <svg
    width="19"
    height="14"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1504 7C12.1504 8.71822 10.7575 10.1111 9.03929 10.1111C7.32107 10.1111 5.92818 8.71822 5.92818 7C5.92818 5.28178 7.32107 3.88889 9.03929 3.88889C10.7575 3.88889 12.1504 5.28178 12.1504 7ZM10.5948 7C10.5948 7.85911 9.8984 8.55556 9.03929 8.55556C8.18018 8.55556 7.48374 7.85911 7.48374 7C7.48374 6.14089 8.18018 5.44444 9.03929 5.44444C9.8984 5.44444 10.5948 6.14089 10.5948 7Z"
      fill="#FCC210"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.03929 0C13.3882 0 17.0425 2.97447 18.0786 7C17.0425 11.0255 13.3882 14 9.03929 14C4.69033 14 1.0361 11.0255 0 7C1.0361 2.97447 4.69033 0 9.03929 0ZM9.03929 12.4444C5.5583 12.4444 2.6081 10.1563 1.61714 7C2.6081 3.84367 5.5583 1.55556 9.03929 1.55556C12.5203 1.55556 15.4705 3.84367 16.4614 7C15.4705 10.1563 12.5203 12.4444 9.03929 12.4444Z"
      fill="#FCC210"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
